import { apiSlice } from "@/shared/api/api-slice"

import type { GetSecurityRulesRequest, GetSecurityRulesResponse, GetSecurityRulesTransformedResponse } from "./types"

// 404 means the chat has no rules yet — mask to []; other errors flow through.
export const getSecurityRulesApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["SecurityRules", "SecurityRule"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getSecurityRulesByChatId: builder.query<GetSecurityRulesTransformedResponse, GetSecurityRulesRequest>({
        queryFn: async (chatId, _api, _extra, baseQuery) => {
          const result = await baseQuery(`/api/v1/security/rules/chat/${chatId}`)
          if (result.error) {
            if (result.error.status === 404) {
              return { data: [] }
            }
            return { error: result.error }
          }
          return { data: (result.data as GetSecurityRulesResponse).result.rules }
        },
        providesTags: (_result, _error, chatId) => [
          { type: "SecurityRules" as const, id: chatId },
          { type: "SecurityRule" as const, id: `${chatId}-trigger_words` }
        ]
      })
    })
  })

export const { useGetSecurityRulesByChatIdQuery } = getSecurityRulesApi
